var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BottomNavComponent',{attrs:{"swiper-color":_vm.colors[_vm.selected],"icon-color":_vm.colors[_vm.selected],"options":_vm.options},on:{"update":_vm.doUpdate},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }